var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4879 0.799988C11.8726 0.799988 10.449 1.53556 9.5182 2.65982C9.51196 2.6533 9.50515 2.64679 9.50005 2.64082C9.49438 2.64733 9.48814 2.6533 9.48247 2.65982C8.55058 1.53556 7.12694 0.799988 5.51215 0.799988C2.70287 0.799988 0.425049 2.9801 0.425049 5.66887C0.425049 7.56453 2.6938 9.4857 2.6938 9.4857L9.50005 16L16.3063 9.4857C16.3063 9.4857 18.575 7.56453 18.575 5.66887C18.575 2.9801 16.2972 0.799988 13.4879 0.799988ZM15.5531 8.67359L15.5287 8.69476L15.5043 8.7181L9.50005 14.4648L3.4958 8.7181L3.47141 8.69476L3.44589 8.67359C2.95754 8.25559 1.56169 6.80724 1.56169 5.66887C1.56169 3.5843 3.33756 1.8857 5.51669 1.8857C6.71176 1.8857 7.83989 2.4139 8.60276 3.33404L9.50005 4.40727L10.3979 3.33404C11.1602 2.4139 12.2872 1.8857 13.4834 1.8857C15.6614 1.8857 17.4384 3.5843 17.4384 5.66887C17.4384 6.80724 16.0426 8.25559 15.5531 8.67359Z",
    fill: "#19191D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEllipse);
export default __webpack_public_path__ + "static/media/likeEllipse.92c1cc96b9ac0787e443c5ed6346051c.svg";
export { ForwardRef as ReactComponent };